import { StringVariants } from '../../../interface/inputs.interface'
import {
  IDependencies,
  IInputType,
} from '../../../interface/steps.interface'
import getCurrentStepNumber from './getCurrentStepNumber'

/**
 * Функция для преобразования объекта input с учетом его типа и имени.
 * @param {any} input - объект ввода.
 * @param {string} name - имя объекта ввода.
 * @returns {Object} новый объект ввода с добавленными полями badge, type, variant, inputType.
 */
const getNewInput = (input: any, name: string) => {
  const badge = input?.percent ? `+${input.percent}%` : null;
  let type: IInputType;
  let variant: StringVariants = StringVariants.default;
  let inputType = 'text';

  switch (input.type) {
    case 'date':
      type = IInputType.date;
      variant = StringVariants.date;
      break;
    case 'bank':
      type = IInputType.bank;
      variant = StringVariants.bankAccount;
      break;
    case 'radio':
      type = IInputType.radio;
      break;
    case 'select':
      type = IInputType.select;
      break;
    case 'checkbox':
      type = IInputType.checkbox;
      break;
    case 'string':
    default:
      type = IInputType.string;
      break;
  }

  switch (name) {
    case 'phone':
      inputType = 'tel';
      break;
    case 'email':
      inputType = 'email';
      break;
    default:
      break;
  }

  const newInput = {
    ...input,
    badge,
    type,
    variant,
    inputType,
  };

  return newInput;
};

const baseDataHandler = (data: any) => {
  
  const { values, steps, inputs } = data
  console.log('baseDataHandler')
  const dependencies: IDependencies = {}
  const dependenciesForCuurentStep: IDependencies = {}

  const amount = document.cookie.replace(/(?:(?:^|.*;\s*)req_amount\s*\=\s*([^;]*).*$)|^.*$/, "$1") || '1000'
  const duration = document.cookie.replace(/(?:(?:^|.*;\s*)req_duration\s*\=\s*([^;]*).*$)|^.*$/, "$1") || '365'
  let newValues = {
    ...values,
    //geo_zip: values?.geo_zip || values?.ApiRequest?.geo_zip || '08001',
    //accept: values?.accept,
    amount: Number(amount) ? amount : 1000,
    duration: Number(duration) ? duration: 3*30
  }

  let newInputs: any = {}
  console.log('values?.ApiRequest--->', values)
  console.log(inputs)
  Object.keys(inputs).forEach(name => {
    if (inputs[name]?.dependencies) {
      dependencies[inputs[name].dependencies.name] = {
        name,
        value: inputs[name].dependencies.value,
      }
      dependenciesForCuurentStep[name] = {
        name: inputs[name].dependencies.name,
        value: inputs[name].dependencies.value,
      }
    }
    
    if (values) {
      const value = values[name]
      newValues[name] = value ? value : ''
    } else {
      newValues[name] = ''
    }
    const newInput = getNewInput(inputs[name], name)
    newInputs[name] = newInput
  })
  // const geo_zip = getGeoZip(values?.geo_zip)
  // newValues.geo_zip = geo_zip
 
  console.log('newValues--->', {...newValues})
  console.log('steps--->', steps)
  console.log('dependencies--->', dependencies)
  const { currentStepNumber, isFullSteps } = getCurrentStepNumber({
    steps, 
    values: newValues, 
    dependencies: dependenciesForCuurentStep
  })
  console.log('currentStepNumber--->', currentStepNumber)
  console.log('isFullSteps---->', isFullSteps)

  return {
    newValues,
    inputsData: newInputs,
    steps,
    dependencies,
    dependenciesForCuurentStep,
    isFullSteps,
    currentStepNumber,
  }
}

export default baseDataHandler
